import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Table } from '../styles';
import { TableProps } from '../table-props';

interface MobileTableProps {
  fireResistanceIndex: number;
}

const MobileViewTable = ({
  fireResistanceIndex,
  structureName,
}: MobileTableProps & TableProps) => {
  const { t } = useTranslation();

  const [index, setIndex] = useState(fireResistanceIndex);

  useEffect(() => {
    setIndex(fireResistanceIndex);
  }, [fireResistanceIndex]);

  return (
    <Table>
      <tbody>
        <Row>
          <td className="bold-text-cell">{`${t(
            `concrete.structuralElements.disclaimer.${
              structureName.split('.')[0]
            }.minLabel`
          )}`}</td>

          <td align={'center'} key={`min`}>
            {
              t(
                `concrete.structuralElements.disclaimer.${structureName}.minValues`
              ).split(';')[index]
            }
          </td>
        </Row>
        <Row>
          <td className="bold-text-cell">{`${t(
            'concrete.structuralElements.disclaimer.requiredAxisDistance'
          )} ${t('concrete.structuralElements.disclaimer.mm')}`}</td>

          <td align={'center'}>
            {
              t(
                `concrete.structuralElements.disclaimer.${structureName}.requiredAxisDistanceValues`
              ).split(';')[index]
            }
          </td>
        </Row>
      </tbody>
    </Table>
  );
};

export default MobileViewTable;
